const actions = {
  PROFILE_CHANGED: 'PROFILE_CHANGED',
};
export default actions;
